import * as antifraud from '@/api/antifraud.api'
import * as authentication from '@/api/authentication.api'
import * as balance from '@/api/balance.api'
import * as cabMessages from '@/api/cabMessages.api'
import * as callers from '@/api/callers.api'
import * as callo from '@/api/callo.api'
import * as campaigns from '@/api/campaigns.api'
import * as complaints from '@/api/complaints.api'
import * as discounts from '@/api/discount.api'
import * as docs from '@/api/docs.api'
import * as firms from '@/api/firms.api'
import * as helps from '@/api/helps.api'
import * as limbo from '@/api/limbo.api'
import * as managers from '@/api/managers.api'
import * as payments from '@/api/payments.api.ts'
import * as phonelists from '@/api/phonelists.api'
import * as reconfirm from '@/api/reconfirm.api'
import * as stafftools from '@/api/stafftools.api'
import * as users from '@/api/users.api'

export interface Data<T> {
  data: {
    data: T
  }
}

export const api = {
  cabMessages,
  balance,
  users,
  helps,
  discounts,
  campaigns,
  phonelists,
  docs,
  firms,
  authentication,
  payments,
  limbo,
  callo,
  stafftools,
  callers,
  managers,
  complaints,
  reconfirm,
  antifraud,
}
